import React from 'react';
import { Home, Sparkles, ShieldCheck, Heart, Award, IndianRupee, MapPin } from 'lucide-react';

export const RunningStrip: React.FC = () => {
  const tickerItems = [
    { icon: Home, text: '100% Home Comfort' },
    { icon: Sparkles, text: 'Best Quality Branded Products' },
    { icon: ShieldCheck, text: 'Sterilized Single-Use Disposables' },
    { icon: Award, text: 'Trained Female Specialists' },
    { icon: IndianRupee, text: 'Zero Hidden Charges' },
    { icon: MapPin, text: 'Doorstep in Bhilai & Durg' },
    { icon: Heart, text: 'Your Beauty, Our Priority' }
  ];

  // Repeat for continuous seamless marquee loop
  const displayItems = [...tickerItems, ...tickerItems, ...tickerItems];

  return (
    <section className="marquee-wrapper" aria-label="Key Highlights">
      <div className="marquee-content">
        {displayItems.map((item, index) => {
          const IconComponent = item.icon;
          return (
            <div key={index} className="marquee-pill">
              <IconComponent size={15} color="var(--blishka-berry)" />
              <span>{item.text}</span>
              <span className="marquee-separator">&bull;</span>
            </div>
          );
        })}
      </div>
    </section>
  );
};
